import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import SsoService from 'cio/services/sso';
import SettingsPersonalIndexController from 'cio/pods/settings/personal/index/controller';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';
import isDestroyed from 'cio/utils/is-destroyed';
import UserModel from 'cio/models/user';
import AccountService from 'cio/services/account';

export default class IndexRoute extends Route {
  @service sso!: SsoService;
  @service store!: DS.Store;
  @service account!: AccountService;

  resetController(controller: SettingsPersonalIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.resetDefaults();
    }
  }

  model() {
    let account = this.account.current;

    return this.store.query('user', {}).then((users) => ({
      users,
      user: account.get('currentUser'),
    }));
  }

  afterModel() {
    return this.sso.initialize();
  }

  deactivate() {
    let { user } = this.controller.model as { user: UserModel };
    if (!isDestroyed(user)) {
      user.rollbackAttributes();
    }

    super.deactivate();
  }

  @action
  refreshModel() {
    return this.refresh();
  }
}
